/**
 * Pure account-credit selection for charge flows. Dependency-free so it can be
 * unit-tested in isolation and shared by the admin event-RSVP charge path
 * (src/components/Forms/EventRSVPForm.js).
 */

/** Coerce a value to a non-negative finite dollar amount; anything else -> 0. */
export function toAmount(v) {
  const n = parseFloat(v);
  return Number.isFinite(n) && n > 0 ? n : 0;
}

/**
 * How much credit to draw from the member's wallet for a charge: their available
 * balance, capped at the charge amount. The card covers the remainder
 * (chargeAmount - this). The admin portal previously ignored the balance entirely
 * (always charged the card), so this restores balance-first billing there too.
 *
 * @param {number} walletAvailable member's available balance (dollars)
 * @param {number} chargeAmount    total charge for the RSVP (dollars)
 * @returns {number} credit to apply from the wallet, 0..chargeAmount
 */
export function computeWalletCredit(walletAvailable, chargeAmount) {
  return Math.min(toAmount(walletAvailable), toAmount(chargeAmount));
}
